import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

const growthMarquee = new CometMarquee('#growth-marquee', {
  speed: 30,
  pauseOnHover: true,
  initialShift: true,
  pauseOnInvisible: true,  
  syncPause: true,         
  repeatCount: 3,    
  forceAnimation: true,  
  forceAnimationWidth: 2, 
});

const marqueeElement = document.querySelector('#numbers-marquee');

if (marqueeElement) {
  const numbersMarquee = new CometMarquee(marqueeElement, {
    speed: 20,
    pauseOnHover: true,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 4,
    forceAnimation: true,
    forceAnimationWidth: 2,
  });

  setTimeout(() => {
    initContainerCountUp({
      container: '.numbers-sec__marquee',
    });
  }, 0)
}